module.exports = __webpack_public_path__ + "img/lincoln-Used.92d50f87.png";